import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CompactButtonComponent } from './compact-button/compact-button.component';
import { PlaceholderLoadingModule } from './placeholder-loading/placeholder-loading.module';
import { GridLoadingPlaceholderComponent } from './grid-loading-placeholder/grid-loading-placeholder.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { DropdownTriggerForDirective } from './dropdown-menu/dropdown-trigger-for.directive';
import { DropdownMenuComponent } from './dropdown-menu/dropdown-menu/dropdown-menu.component';
import { OverlayModule } from '@angular/cdk/overlay';



@NgModule({
  declarations: [
    CompactButtonComponent,
    GridLoadingPlaceholderComponent,
    DropdownTriggerForDirective,
    DropdownMenuComponent,
  ],
  imports: [
    CommonModule,
    OverlayModule,
    FontAwesomeModule,
    PlaceholderLoadingModule
  ],
  exports: [
    CompactButtonComponent,
    PlaceholderLoadingModule,
    GridLoadingPlaceholderComponent,
    DropdownTriggerForDirective,
    DropdownMenuComponent
  ]
})
export class ElementsModule { }
